import { render, staticRenderFns } from "./TeltonikaMap.vue?vue&type=template&id=8dfb5afc&scoped=true"
import script from "./TeltonikaMap.vue?vue&type=script&lang=js"
export * from "./TeltonikaMap.vue?vue&type=script&lang=js"
import style0 from "./TeltonikaMap.vue?vue&type=style&index=0&id=8dfb5afc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfb5afc",
  null
  
)

export default component.exports